import Overlay from "../../../Componentes/Overlay/index.js"
import Modal from "../../../Componentes/Utils/Modal";
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import { useMemo, useState } from "react";
import TableNFs from "./TableNFs.jsx";
import ModalAddValorNF from "./ModalAddValorNF.jsx";
import { useModal } from "../../../contexts/ModalContext.js";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader/index.js";
import { formatBRLFromCents } from "../../../Funcoes/Money/index.jsx";
import useApi from "../../../hooks/useApi.js";

const ModalNovaNF = ({ bm, fecharModal, fetchData }) => {

    const { isModalOpen } = useModal();
    const api = useApi();

    const [listaNF, setListaNF] = useState([])
    // Criar estado para data de emissão da NF, onde o valor padrão será a data atual
    const [dataEmissaoNF, setDataEmissaoNF] = useState(new Date().toISOString().split("T")[0])
    const [files, setFiles] = useState([])

    const valorNF = useMemo(() => {

        const totalValorNF = listaNF.reduce((acc, nf) => acc + parseInt(nf.valorNF), 0);
        return totalValorNF;

    }, [listaNF])

    const canSave = useMemo(() => {

        return valorNF === bm.valor;

    }, [valorNF])

    const [ saving, setSaving ] = useState(false);

    const handleSave = async (e) => {

        e.preventDefault();

        if (!canSave) {
            alert("O valor total das NFs deve ser igual ao valor da medição.");
            return;
        }

        if( listaNF.length === 0 ){
            alert("Adicione pelo menos uma NF para continuar.");
            return;
        }

        setSaving(true);

        try{

            const formData = new FormData();

            formData.append("idBM", bm.id);
            formData.append("dataEmissaoNF", dataEmissaoNF);
            //Adicionar listaNF como JSON stringifyada
            formData.append("listaNF", JSON.stringify(listaNF));
            //Adicionar arquivos ao formData em um array chamado "files[]"
            files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });

            const { data } = await api.post("/Painel/API/ControleMedicao/AdicionarNF/", formData );
            console.log( data );

            fetchData();
            fecharModal();

        }catch(e){

            console.log(e);

        }finally{

            setSaving(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal
                    header
                    close={fecharModal}
                >
                    <Formulario onSubmit={handleSave} >
                        <FormComp
                            title="NÚMERO BM"
                            type="text"
                            readOnly
                            valor={bm.num_medicao}
                        />
                        <FormComp
                            title="VALOR A DISTRIBUIR"
                            type="text"
                            readOnly
                            valor={formatBRLFromCents(bm.valor)}
                        />
                        <FormComp
                            title="DATA DE EMISSÃO"
                            type="date"
                            valor={ dataEmissaoNF }
                            onChange={(e) => setDataEmissaoNF(e.target.value)}
                        />
                        <TableNFs
                            listaNF={listaNF}
                            setListaNF={setListaNF}
                        />
                        <MultiFileUploader
                            files={files}
                            setFiles={setFiles}
                        />
                        <FormComp
                            valor={ saving ? "SALVANDO..." : "SALVAR NF" }
                            type="submit"
                            disabled={!canSave}
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {
                isModalOpen('addValorNF') && (
                    <ModalAddValorNF
                        setListaNF={setListaNF}
                    />
                )
            }
        </>
    )
}

export default ModalNovaNF;